export const PostureManagementTabs = {
  USER_SECURITY_POSTURE: 'users',
  // KIR-5412: one row per physical machine, gated by `shared_devices`.
  ENDPOINTS: 'endpoints',
  PROJECTS: 'projects',
  MCP: 'mcp',
  EXTENSIONS: 'extensions',
  PLUGINS: 'plugins',
  AI_INSTRUCTIONS: 'ai-instructions',
  SKILLS: 'skills',
  HOOKS: 'hooks',
} as const;

/**
 * Default page size for posture management tabs (shared constant)
 * Note: only the frontend ?tab= URL value was renamed to "users"; the backend
 * API route path (/user-security-posture) and its file name were intentionally
 * left unchanged. This constant is shared with the backend via that file.
 */
export const DEFAULT_POSTURE_PAGE_SIZE = 50;
